import config from '../config';

export async function fetchSiteProperties(backendFetch, siteId) {
  const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/properties/" + siteId);
  const text = await response.text();
  if (!text) return null;
  return JSON.parse(text);
}
